import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';

import { ProcModal, Button, ButtonIcon, Footer } from '@sonyged/ext-proc';

export default class ResearchIntroModal extends React.Component {
  static MAX_PAGE = 4;

  constructor(props) {
    super(props);

    this.state = {
      isOpened: true,
      sliderEnded: false,
      sliderIndex: 0,
    };
  }

  render() {
    let settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      afterChange: this._onSliderChange.bind(this),
    };

    return (
      <ProcModal isOpened={this.state.isOpened} rootNodeId={'proc-ice-fields-root-page'}>
        {this._renderSliderControlBtn()}
        <div key="modal" className={'proc-modal proc-modal--hint'}>
          <div className="proc-modal-container">
            <div className={'proc-modal-header'}>{this.props.title}</div>
            <div className={'proc-modal-contents gray100-color proc-font-medium'}>
              <div className={'slider-container'}>
                <Slider
                  {...settings}
                  ref={v => {
                    this.slider = v;
                  }}
                >
                  {this._renderPage1()}
                  {this._renderPage2()}
                  {this._renderPage3()}
                  {this._renderPage4()}
                </Slider>
              </div>
            </div>
          </div>
          <Footer.normal shadow={false}>{this._renderNextBtn()}</Footer.normal>
        </div>
      </ProcModal>
    );
  }

  _renderSliderControlBtn() {
    return (
      <React.Fragment>
        <Button.dark
          disabled={this.state.sliderEnded}
          className={`slider-control next`}
          onClick={this._onNext.bind(this)}
        >
          <ButtonIcon.next />
        </Button.dark>
        <Button.dark
          disabled={this.state.sliderIndex === 0}
          className={`slider-control prev`}
          onClick={this._onPrev.bind(this)}
        >
          <ButtonIcon.back />
        </Button.dark>
      </React.Fragment>
    );
  }

  _renderPage1() {
    return (
      <div className="Container">
        <div className="Figure white-bg-color">
          <img alt="" src={'../../images/pages/ice/fields/img-research-intro01.png'} />
        </div>
        <div className="TextElementView proc-medium-font">
          どうしたら もらえる おかねが ふえるのかを しらべる ばしょだよ。
        </div>
      </div>
    );
  }

  _renderPage2() {
    return (
      <div className="Container">
        <div className="Figure white-bg-color">
          <img alt="" src={'../../images/pages/ice/fields/img-research-intro02.png'} />
        </div>
        <div className="TextElementView proc-medium-font">おなじ ひに なんかいも うりに いけるよ。</div>
      </div>
    );
  }

  _renderPage3() {
    return (
      <div className="Container">
        <div className="Figure white-bg-color">
          <img alt="" src={'../../images/pages/ice/fields/img-research-intro03.png'} />
        </div>
        <div className="TextElementView proc-medium-font">
          ばしょ、アイス、ねだんを かえて いろいろ ためして みよう。
        </div>
      </div>
    );
  }

  _renderPage4() {
    return (
      <div className="Container">
        <div className="Figure white-bg-color">
          <img alt="" src={'../../images/pages/ice/fields/img-research-intro04.png'} />
        </div>
        <div className="TextElementView proc-medium-font">
          たくさん しらべて、おかねを たくさん もらえるように なろう！
        </div>
      </div>
    );
  }

  _renderPrevBtn() {
    if (this.state.sliderIndex === 0) {
      return (
        <Link to={'/ice'} className={'proc-button proc-button--dark'}>
          <i className={'icon-proc-back'} />
        </Link>
      );
    }
    return (
      <Button.dark className={'prev'} onClick={this._onPrev.bind(this)}>
        <i className={'icon-proc-back'} />
      </Button.dark>
    );
  }

  _renderNextBtn() {
    if (this.state.sliderEnded) {
      return (
        <Button.attention className={'modal-close-se'} onClick={this._onClose.bind(this)}>
          とじる
        </Button.attention>
      );
    } else {
      return <Button.attention onClick={this._onNext.bind(this)}>つぎへ</Button.attention>;
    }
  }

  _onClose() {
    this.setState({
      isOpened: false,
      sliderEnded: false,
    });
    this.props.onNextClick();
  }

  _onSliderChange(index) {
    this.setState({ sliderEnded: ResearchIntroModal.MAX_PAGE === index + 1, sliderIndex: index });
  }

  _onNext() {
    if (this.slider) this.slider.slickNext();
  }

  _onPrev() {
    if (this.slider) this.slider.slickPrev();
  }
}

ResearchIntroModal.propTypes = {
  results: PropTypes.array,
  onNextClick: PropTypes.func,
  title: PropTypes.string.isRequired,
};

ResearchIntroModal.defaultProps = {};
